import { render, staticRenderFns } from "./sk-radio-wap.vue?vue&type=template&id=6a2b0a48&scoped=true&"
import script from "./sk-radio-wap.vue?vue&type=script&lang=js&"
export * from "./sk-radio-wap.vue?vue&type=script&lang=js&"
import style0 from "./sk-radio-wap.vue?vue&type=style&index=0&id=6a2b0a48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2b0a48",
  null
  
)

export default component.exports